import React, { useEffect, useState } from 'react';
import { getAssetsImages } from '@/utils/tools';
import { Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Image } from 'antd';
import './index.scss';

function Index() {
  const [advantagesList, setAdvantagesList] = useState([
    {
      icon: '',
      title: '平台优势',
      desc: '带量扶持，入驻即推送周边【15公里】维修工程师配件需求',
    },
    {
      icon: '',
      title: '生态打造',
      desc: '携手国内维保平台，打造配件生态圈',
    },
    {
      icon: '',
      title: '一站式服务',
      desc: '零元入驻，官方1V1指导运营，资金平台保障，安全无忧',
    },
  ]);

  useEffect(() => {
    const list = advantagesList.map((item, index) => {
      return {
        ...item,
        icon: getAssetsImages(`invest/advantages_${index + 1}.png`),
      };
    });
    setAdvantagesList(list);
  }, []);
  return (
    <>
      <div className="invest-container">
        <div className="invest-main-img">
          <div className="left-container">
            <div className="title">打造全品类配件生态体系</div>
            <div className="sub-title">
              携手国内服务企业开启数亿级配件新蓝海
            </div>
            <div className="advantages">
              {advantagesList.map((item, index) => {
                return (
                  <div className="advantages-item" key={item.title}>
                    <div className="item-icon">
                      <img src={item.icon} alt="icon" />
                    </div>
                    <div className="item-info">
                      <div className="item-title">{item.title}</div>
                      <div className="item-desc">{item.desc}</div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="description">
              啄木鸟家庭维修，全国最大的数字化一站式家庭维修服务提供商，95家全资子公司，覆盖全国2000+县级及以上城市。
              300+家电家居设施类别，95万+工程师人才池。每年为3000万家庭提供服务，
              已经向港交所递交招股书，拟于香港主板IPO上市。
            </div>
          </div>
          <div className="right-container">
            <div className="slogan-bg"></div>
            <div className="slogan-tag"></div>
            <div className="join-container">
              <div className="join-text"></div>
              <div className="join-qr-code-wrap">
                <div className="qr-code-container">
                  <Image
                    src={getAssetsImages('invest/gzh-qrcode.jpg')}
                    alt="二维码"
                    className="qrcode"
                  />
                  <div className="qr-code-text">
                    官方公众号
                    <br />
                    24小时应答
                  </div>
                </div>
                <div className="qr-code-container">
                  <Image
                    src={getAssetsImages('invest/wechat-qrcode-zc.jpg')}
                    alt="二维码"
                    className="qrcode"
                  />
                  <div className="qr-code-text">
                    企业微信 <br />
                    了解更多详情
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="invest-content">
          <div className="card-wrap">
            <div className="content-card">
              <div className="card-header">
                <img
                  src={getAssetsImages('invest/t1.png')}
                  alt="入驻流程"
                  className="header-img"
                />
                <div className="header-info">
                  <div className="title">入驻流程</div>
                  <div className="sub-title">
                    个体工商户/公司企业/个人独资企业等
                  </div>
                </div>
              </div>
              <div className="card-content">
                <div className="process-item">
                  <div className="process-num-container">
                    <div className="num">01</div>
                    <div className="num-link"></div>
                  </div>
                  <div className="item-info">
                    <div className="item-title">
                      提交材料
                      <span className="tag">约10分钟左右</span>
                    </div>
                    <div className="item-desc">
                      上传营业执照、经营者身份证件等相关材料
                    </div>
                  </div>
                </div>
                <div className="process-item">
                  <div className="process-num-container">
                    <div className="num">02</div>
                  </div>
                  <div className="item-info">
                    <div className="item-title">
                      平台审核
                      <span className="tag">约1~3个工作日</span>
                    </div>
                    <div className="item-desc">平台进行资质审核</div>
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <Button type="link" href="/#/website/settle-in">
                  查看详情 <RightOutlined className="right-icon" />
                </Button>
              </div>
            </div>
            <div className="content-card">
              <div className="card-header">
                <img
                  src={getAssetsImages('invest/t2.png')}
                  alt="资质要求"
                  className="header-img"
                />
                <div className="header-info">
                  <div className="title">资质要求</div>
                  <div className="sub-title">
                    明确标准，助力合规入驻，开启新篇章
                  </div>
                </div>
              </div>
              <div className="card-content">
                <div className="qualification-item">
                  <div className="item-num">01</div>
                  <div className="item-info">认同啄木鸟企业文化和经营理念</div>
                </div>
                <div className="qualification-item">
                  <div className="item-num">02</div>
                  <div className="item-info">申请者为本地人或有本地资源</div>
                </div>
                <div className="qualification-item">
                  <div className="item-num">03</div>
                  <div className="item-info">参与门店实体经营</div>
                </div>
                <div className="qualification-item">
                  <div className="item-num">04</div>
                  <div className="item-info">
                    有销售经验或蓝领管理经验者优先
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <Button type="link" href="/#/website/qualification">
                  查看详情 <RightOutlined className="right-icon" />
                </Button>
              </div>
            </div>
            <div className="content-card">
              <div className="card-header">
                <img
                  src={getAssetsImages('invest/t3.png')}
                  alt="常见问题"
                  className="header-img"
                />
                <div className="header-info">
                  <div className="title">常见问题</div>
                  <div className="sub-title">一站式解答，助您快速解决疑惑</div>
                </div>
              </div>
              <div className="card-content">
                <div className="question-item">
                  <div className="item-wrap">
                    <div className="item-title">开店管理</div>
                    <RightOutlined className="right-icon" />
                  </div>
                  <div className="item-wrap">
                    <div className="item-title">账号管理</div>
                    <RightOutlined className="right-icon" />
                  </div>
                  <div className="item-wrap">
                    <div className="item-title">商品管理</div>
                    <RightOutlined className="right-icon" />
                  </div>
                  <div className="item-wrap">
                    <div className="item-title">订单管理</div>
                    <RightOutlined className="right-icon" />
                  </div>
                  <div className="item-wrap">
                    <div className="item-title">资金管理</div>
                    <RightOutlined className="right-icon" />
                  </div>
                </div>
              </div>
              <div className="card-footer">
                <Button type="link" href="/#/website/questions">
                  更多帮助 <RightOutlined className="right-icon" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Index;